<template>
  <div class="shop-breadcrumb">
    <ul>
      <li><a :href="system.domain">Home</a></li>
      <li><a :href="routePath">{{routeName}}</a></li>
      <li v-if="addRoute.name!=''"><a :href="addRoute.path">{{addRoute.name}}</a></li>
    </ul>
  </div>
</template>

<script>

    import request from '@/utils/request'
    export default {
        name: "breadcrumb",
        props:{
          pathId:{
            type:Number,
            default:0
          },
          addRoute:{
            required:false,
            type: Object,
            default: function () {
              return { name:'',path:''}
            }
          }
        },
        data(){
          return {
            routeName:'',
            routePath:''
          }
        },
        watch:{
          '$route':function(newVal,oldVal){
              this.getProductCategoryInfo()
            //this.routeName = this.$route.params.name || this.$route.params.path
           }
        },
        mounted(){
          this.getProductCategoryInfo()
          //this.routeName = this.$route.params.name || this.$route.params.path
        },
        methods:{
          getProductCategoryInfo(){
            if(this.$route.params.name!=null && this.$route.params.name!=""){
                this.routeName = this.$route.params.name
            }else if(this.$route.params.path!=null && this.$route.params.path!=""){
              request({
                  url:"/productCategory/item",
                  method:"GET",
                  params:{path:this.$route.params.path}
              }).then(res=>{
                  if(res.data.code===200){
                    this.routeName = res.data.data.name || this.$route.params.path
                    this.routePath = "/product/"+res.data.data.path
                  }
              });
            }else if(this.pathId>0){
              request({
                url:"/productCategory/item",
                method:"GET",
                params:{path:this.pathId}
              }).then(res=>{
                if(res.data.code===200){
                  this.routeName = res.data.data.name || this.$route.params.path
                  this.routePath = "/product/"+res.data.data.path
                }
              });

            }
          }
        }
    }
</script>

<style scoped>

</style>
